import _styled52 from "../web_modules/styled-components.js";
import _styled51 from "../web_modules/styled-components.js";
import _styled50 from "../web_modules/styled-components.js";
import _styled49 from "../web_modules/styled-components.js";
import _styled48 from "../web_modules/styled-components.js";
import _styled47 from "../web_modules/styled-components.js";
import _styled46 from "../web_modules/styled-components.js";
import _styled45 from "../web_modules/styled-components.js";
import _styled44 from "../web_modules/styled-components.js";
import _styled43 from "../web_modules/styled-components.js";
import _styled42 from "../web_modules/styled-components.js";
import _styled41 from "../web_modules/styled-components.js";
import _styled40 from "../web_modules/styled-components.js";
import _styled39 from "../web_modules/styled-components.js";
import _styled38 from "../web_modules/styled-components.js";
import _styled37 from "../web_modules/styled-components.js";
import _styled36 from "../web_modules/styled-components.js";
import _styled35 from "../web_modules/styled-components.js";
import _styled34 from "../web_modules/styled-components.js";
import _styled33 from "../web_modules/styled-components.js";
import _styled32 from "../web_modules/styled-components.js";
import _styled31 from "../web_modules/styled-components.js";
import _styled30 from "../web_modules/styled-components.js";
import _styled29 from "../web_modules/styled-components.js";
import _styled28 from "../web_modules/styled-components.js";
import _styled27 from "../web_modules/styled-components.js";
import _styled26 from "../web_modules/styled-components.js";
import _styled25 from "../web_modules/styled-components.js";
import _styled24 from "../web_modules/styled-components.js";
import _styled23 from "../web_modules/styled-components.js";
import _styled22 from "../web_modules/styled-components.js";
import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../web_modules/react.js";
import { ProgressBar } from "../web_modules/react-milestone.js";
import { SeatingDetails } from "./seating_details.js";
import { formatDate, formatDateTimeRange, makeDate } from "../web_modules/@ticketbutler/toolbox.js";
import { Switch, Route, useParams, useRouteMatch, useLocation, useHistory } from "../web_modules/react-router-dom.js";
import { useAsyncStatus } from "../web_modules/use-async-status.js";
import { PurchaseDetails, makeSearchParamString, useLanguage, getRegistraionFormValuesFromReservation, getOrderSummaryFromPurchase, PAYMENT_PROVIDERS, API_HOST, makeTbRequestHeaders, PaymentRoute, AttendeeQuestions, StripePayment, styles, paymentOption, InvoiceForm, QuickPay, PurchaseCancelled, PurchaseSuccess, Countdown, RegistrationDialog, MobilePayCheckout } from "./app.js";
import { Services } from "./services.js";
import { ExtrasTypes } from "./extras.js";
import { getSearchParams, isIframe, releaseSeatsioObjects, urlParams, useIframeTypes } from "./shared.js";
import mobilepayIcon from "./assets/icons/mobilepay.png";
import locationIcon from "./assets/icons/location.svg";
import calendarIcon from "./assets/icons/calendar.svg";
import { useTranslation } from "../web_modules/react-i18next.js";
var CheckoutSteps;

(function (CheckoutSteps) {
  CheckoutSteps["Extras"] = "Extras";
  CheckoutSteps["OrderInformation"] = "OrderInformation";
  CheckoutSteps["InformationPerGuest"] = "InformationPerGuest";
  CheckoutSteps["Payment"] = "Payment";
  CheckoutSteps["Services"] = "Services";
  CheckoutSteps["MobilePay"] = "MobilePay";
})(CheckoutSteps || (CheckoutSteps = {}));

const ORDER_SUMMARY_BREAKPOINT = 760;
export const CHECKOUT_DIALOG_BORDER_RADIUS = 5;
export const CheckoutContext = /*#__PURE__*/React.createContext({
  warnBeforeExit: true,
  checkoutComplete: false,
  setCheckoutContext: function () {
    console.error("CheckoutContext not initiated");
  }
});
export const CHECKOUT_ROUTE = "checkout"; // Map of checkout paths for managing progress bars and returning URLS

export const CHECKOUT_PATHS = {
  [CheckoutSteps.Extras]: {
    extrasTypes: "extras-types"
  },
  [CheckoutSteps.OrderInformation]: {
    purchaseDetails: "/"
  },
  [CheckoutSteps.Services]: {
    services: "services"
  },
  [CheckoutSteps.InformationPerGuest]: {
    attendeeDetails: "attendee-details"
  },
  [CheckoutSteps.MobilePay]: {
    mobilePayCheckout: "mobilepay-checkout"
  },
  [CheckoutSteps.Payment]: {
    stripe: "stripe",
    selectPayment: "select-payment",
    invoice: "invoice",
    card: "card",
    mobilepay: "mobilepay"
  },
  Cancel: {
    cancelled: "cancelled"
  },
  Success: {
    success: "success",
    invoiceConfirmation: "invoice-confirmation"
  }
};

var _StyledDiv = _styled("div").withConfig({
  displayName: "checkout___StyledDiv",
  componentId: "sc-1fg0buz-0"
})({
  flexGrow: 1,
  // Fill content box to bottom
  display: "flex",
  justifyContent: "space-between",
  [`@media (max-width: ${ORDER_SUMMARY_BREAKPOINT}px)`]: {
    // Put the order summary on top
    flexDirection: "column-reverse",
    alignItems: "center",
    overflow: "hidden",
    overflowY: "auto"
  }
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv2",
  componentId: "sc-1fg0buz-1"
})({
  padding: 35,
  flexGrow: 1,
  width: "100%",
  "@media (max-width: 450px)": {
    paddingBottom: 30
  }
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv3",
  componentId: "sc-1fg0buz-2"
})({
  height: 70,
  width: "85%",
  maxWidth: 600,
  margin: "0 auto",
  marginTop: 15,
  marginBottom: 35,
  "@media (max-width: 1000px)": {
    width: "85%"
  },
  "@media (max-width: 620px)": {
    display: "none"
  }
});

var _StyledP = _styled("p").withConfig({
  displayName: "checkout___StyledP",
  componentId: "sc-1fg0buz-3"
})(["", ""], p => p._css);

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv4",
  componentId: "sc-1fg0buz-4"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 50
});

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv5",
  componentId: "sc-1fg0buz-5"
})(["", ""], p => p._css2);

var _StyledImg = _styled("img").withConfig({
  displayName: "checkout___StyledImg",
  componentId: "sc-1fg0buz-6"
})({
  width: "100%",
  height: "100%"
});

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv6",
  componentId: "sc-1fg0buz-7"
})(["", ""], p => p._css3);

var _StyledDiv7 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv7",
  componentId: "sc-1fg0buz-8"
})(["", ""], p => p._css4);

var _StyledDiv8 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv8",
  componentId: "sc-1fg0buz-9"
})({
  display: "none",
  "@media (max-width: 760px)": {
    display: "block",
    marginTop: 40
  }
});

var _StyledDiv9 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv9",
  componentId: "sc-1fg0buz-10"
})(p => ({
  width: "100%",
  maxWidth: 400,
  minHeight: 45,
  padding: 10,
  backgroundColor: "#F9F9FC",
  borderTopRightRadius: p._css5,
  borderBottomRightRadius: p._css6,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "@media (max-width: 760px)": {
    // Full width in mobile view
    width: "100%",
    maxWidth: "100%",
    padding: 10
  }
}));

var _StyledDiv10 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv10",
  componentId: "sc-1fg0buz-11"
})({
  // Hide in desktop mode always
  "@media (min-width: 761px)": {
    display: "none"
  }
});

var _StyledDiv11 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv11",
  componentId: "sc-1fg0buz-12"
})({
  fontSize: 14,
  padding: "10px",
  textAlign: "center"
});

var _StyledDiv12 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv12",
  componentId: "sc-1fg0buz-13"
})(["", ""], p => p._css7);

var _StyledP2 = _styled("p").withConfig({
  displayName: "checkout___StyledP2",
  componentId: "sc-1fg0buz-14"
})(["", ""], p => p._css8);

var _StyledDiv13 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv13",
  componentId: "sc-1fg0buz-15"
})({
  display: "flex",
  alignItems: "center",
  marginTop: 10,
  marginBottom: 10
});

var _StyledDiv14 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv14",
  componentId: "sc-1fg0buz-16"
})({
  fontSize: 14,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  textAlign: "center",
  span: {
    whiteSpace: "normal",
    margin: "2px 0",
    display: "block"
  }
});

var _StyledDiv15 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv15",
  componentId: "sc-1fg0buz-17"
})({
  display: "flex",
  flexDirection: "column",
  marginBottom: 20
});

var _StyledImg2 = _styled("img").withConfig({
  displayName: "checkout___StyledImg2",
  componentId: "sc-1fg0buz-18"
})({
  margin: "0px 10px 0px 2px",
  width: "15px"
});

var _StyledP3 = _styled("p").withConfig({
  displayName: "checkout___StyledP3",
  componentId: "sc-1fg0buz-19"
})(["", ""], p => p._css9);

var _StyledTable = _styled("table").withConfig({
  displayName: "checkout___StyledTable",
  componentId: "sc-1fg0buz-20"
})({
  borderCollapse: "collapse",
  width: "100%",
  margin: "15px 0"
});

var _StyledTbody = _styled("tbody").withConfig({
  displayName: "checkout___StyledTbody",
  componentId: "sc-1fg0buz-21"
})({
  td: {
    borderBottom: "1px solid #E2E2E2",
    padding: "10px 5px",
    fontWeight: 400,
    fontSize: 14
  }
});

var _StyledTr = _styled("tr").withConfig({
  displayName: "checkout___StyledTr",
  componentId: "sc-1fg0buz-22"
})({
  td: {
    verticalAlign: "bottom"
  }
});

var _StyledDiv16 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv16",
  componentId: "sc-1fg0buz-23"
})({
  fontWeight: "bold",
  marginBottom: 5,
  minWidth: 224
});

var _StyledDiv17 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv17",
  componentId: "sc-1fg0buz-24"
})({
  marginBottom: 5
});

var _StyledTd = _styled("td").withConfig({
  displayName: "checkout___StyledTd",
  componentId: "sc-1fg0buz-25"
})({
  textAlign: "right"
});

var _StyledDiv18 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv18",
  componentId: "sc-1fg0buz-26"
})({
  marginBottom: 5
});

var _StyledTd2 = _styled("td").withConfig({
  displayName: "checkout___StyledTd2",
  componentId: "sc-1fg0buz-27"
})({
  textAlign: "right"
});

var _StyledTd3 = _styled("td").withConfig({
  displayName: "checkout___StyledTd3",
  componentId: "sc-1fg0buz-28"
})({
  textAlign: "right"
});

var _StyledTd4 = _styled("td").withConfig({
  displayName: "checkout___StyledTd4",
  componentId: "sc-1fg0buz-29"
})({
  textAlign: "right"
});

var _StyledTd5 = _styled("td").withConfig({
  displayName: "checkout___StyledTd5",
  componentId: "sc-1fg0buz-30"
})({
  textAlign: "right"
});

var _StyledTd6 = _styled("td").withConfig({
  displayName: "checkout___StyledTd6",
  componentId: "sc-1fg0buz-31"
})({
  textAlign: "right"
});

var _StyledDiv19 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv19",
  componentId: "sc-1fg0buz-32"
})({
  marginBottom: 5
});

var _StyledTd7 = _styled("td").withConfig({
  displayName: "checkout___StyledTd7",
  componentId: "sc-1fg0buz-33"
})({
  textAlign: "right"
});

var _StyledTr2 = _styled("tr").withConfig({
  displayName: "checkout___StyledTr2",
  componentId: "sc-1fg0buz-34"
})({
  fontStyle: "italic"
});

var _StyledTd8 = _styled("td").withConfig({
  displayName: "checkout___StyledTd8",
  componentId: "sc-1fg0buz-35"
})({
  textAlign: "right"
});

var _StyledTd9 = _styled("td").withConfig({
  displayName: "checkout___StyledTd9",
  componentId: "sc-1fg0buz-36"
})({
  fontSize: 16
});

var _StyledTd10 = _styled("td").withConfig({
  displayName: "checkout___StyledTd10",
  componentId: "sc-1fg0buz-37"
})({
  textAlign: "right"
});

var _StyledTr3 = _styled("tr").withConfig({
  displayName: "checkout___StyledTr3",
  componentId: "sc-1fg0buz-38"
})({
  fontStyle: "italic"
});

var _StyledTd11 = _styled("td").withConfig({
  displayName: "checkout___StyledTd11",
  componentId: "sc-1fg0buz-39"
})({
  textAlign: "right"
});

var _StyledDiv20 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv20",
  componentId: "sc-1fg0buz-40"
})({
  fontSize: 14,
  padding: "10px",
  textAlign: "center",
  "@media (max-width: 760px)": {
    display: "none"
  }
});

var _StyledP4 = _styled("p").withConfig({
  displayName: "checkout___StyledP4",
  componentId: "sc-1fg0buz-41"
})(["", ""], p => p._css10);

var _StyledDiv21 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv21",
  componentId: "sc-1fg0buz-42"
})({
  backgroundColor: "white",
  margin: "2%",
  padding: "2%"
});

var _StyledDiv22 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv22",
  componentId: "sc-1fg0buz-43"
})({
  fontSize: 14,
  textAlign: "center",
  padding: "5px",
  display: "flex",
  backgroundColor: "#DDDDDD",
  width: "fit-content",
  borderRadius: 5,
  margin: "auto",
  justifyContent: "center",
  [`@media (min-width: ${ORDER_SUMMARY_BREAKPOINT + 1}px)`]: {
    display: "none"
  }
});

var _StyledDiv23 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv23",
  componentId: "sc-1fg0buz-44"
})({
  marginTop: 2
});

var _StyledDiv24 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv24",
  componentId: "sc-1fg0buz-45"
})(["", ""], p => p._css11);

var _StyledDiv25 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv25",
  componentId: "sc-1fg0buz-46"
})({
  "@media (max-width: 760px)": {
    display: "none"
  }
});

export function Checkout({
  event,
  whitelabel,
  theme,
  existingReservation,
  seatsHaveTicketTypeOptions
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const checkoutNavigate = useCheckoutNavigate();
  const {
    path
  } = useRouteMatch();
  const location = useLocation();
  const {
    eventSlug
  } = useParams();
  const history = useHistory();
  const {
    isDetailIframe
  } = useIframeTypes(whitelabel);
  const isExtrasEvent = urlParams.get("extras_flow");
  const {
    checkoutComplete,
    setCheckoutContext,
    warnBeforeExit
  } = React.useContext(CheckoutContext);
  const [reservation, setReservation] = React.useState(existingReservation); // State for show/hiding summary on mobile

  const [orderDetailsShown, setOrderDetailsShown] = React.useState(false); // Store completed forms in here to handle back/forward navigation

  const [registrationFormValues, setRegistrationFormValues] = React.useState( // If we have fetched an existing reservation
  getRegistraionFormValuesFromReservation(reservation)); // For the Summary panel

  const [orderSummary, setOrderSummary] = React.useState(getOrderSummaryFromPurchase(reservation.purchase));

  function getNextPath(purchaseIsFree, servicesComplete = false, ticketQuestionsCompleted = false) {
    // General overview of possible positive checkout steps
    // 0. [Before] Extras
    // 1. Purchase details
    // 2. ?Services page
    // 3. ?Ticket questions
    // 4. ?Select payment type
    // 5. ?Invoice payment form / ?Stripe payment / ?Card payment
    // 6. Success page
    switch (true) {
      // If the user has submitted the purchase details form, next is the
      // services page
      case !servicesComplete && getShowServicesPage(purchaseIsFree, event.eventsettings.invoice_payment_optional, event.eventsettings.invoice_payment_only, whitelabel, event):
        return "services";

      case reservation.purchase.has_active_ticket_questions && !ticketQuestionsCompleted:
        return CHECKOUT_PATHS.InformationPerGuest.attendeeDetails;
      // Immediate payment is not required, show success

      case purchaseIsFree:
      case reservation.purchase.pay_by_invoice:
      case reservation.purchase.pay_by_voucher:
        return "success";
      // The order needs to be paid

      case event.eventsettings.invoice_payment_optional:
        return CHECKOUT_PATHS.Payment.selectPayment;

      case event.eventsettings.invoice_payment_only:
        return CHECKOUT_PATHS.Payment.invoice;
      // Check if Stripe is used for this Whitelabel

      case whitelabel.payment_provider === PAYMENT_PROVIDERS.STRIPE:
      case whitelabel.payment_provider === PAYMENT_PROVIDERS.STRIPE_CONNECT:
        return CHECKOUT_PATHS.Payment.stripe;
      // Use the default payment gateway

      default:
        return CHECKOUT_PATHS.Payment.card;
    }
  } // Make a list of steps to complete to show the user


  const checkoutSteps = React.useMemo(function () {
    const steps = [];

    if (reservation.purchase.has_active_extras_types && !isExtrasEvent) {
      steps.push(CheckoutSteps.Extras);
    } // Order Information is for all flows


    steps.push(CheckoutSteps.OrderInformation);

    if (getShowServicesPage(reservation.purchase.purchase_is_free, event.eventsettings.invoice_payment_optional, event.eventsettings.invoice_payment_only, whitelabel, event)) {
      steps.push(CheckoutSteps.Services);
    }

    if (reservation.purchase.has_active_ticket_questions) {
      steps.push(CheckoutSteps.InformationPerGuest);
    }

    if (!reservation.purchase.purchase_is_free) {
      steps.push(CheckoutSteps.Payment);
    }

    return steps;
  }, [reservation.purchase.has_active_extras_types, reservation.purchase.has_active_ticket_questions, reservation.purchase.purchase_is_free, event, whitelabel, isExtrasEvent]); // Find the current step buy checking the paths in each step with the current
  // URL

  const currentStepID = React.useMemo(function () {
    const urlPathnameParts = location.pathname.split("/").filter(part => part !== "");
    const currentUrlSlug = urlPathnameParts.reverse()[0];

    if (currentUrlSlug === CHECKOUT_ROUTE) {
      // This is the root
      return CheckoutSteps.OrderInformation;
    }

    for (const stepID of checkoutSteps) {
      const pathsForStep = CHECKOUT_PATHS[stepID];

      for (const pathID in pathsForStep) {
        const path = pathsForStep[pathID];

        if (currentUrlSlug === path.replace("/", "")) {
          // Current path is in this step
          return stepID;
        }
      }
    }
  }, [checkoutSteps, location.pathname]);
  const countdownElement = !checkoutComplete && /*#__PURE__*/React.createElement(Countdown, {
    seconds: reservation.purchase.purchase_timeout,
    onEnd: async function () {
      if (warnBeforeExit) {
        // Turn off exit warning so we don't show 2 dialogs
        setCheckoutContext(ctx => ({ ...ctx,
          warnBeforeExit: false
        }));
        window.alert(t("event.refreshToReserveAgain"));
        history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
      }
    }
  });
  const ticketTypesByUUID = React.useMemo(() => event.ticket_types.reduce(function (acc, ticketType) {
    acc[ticketType.uuid] = ticketType;
    return acc;
  }, {}), [event.ticket_types]); // For detailed iframes, send a message that we are back from any payment
  // windows

  React.useEffect(function () {
    if (isDetailIframe) {
      parent.postMessage({
        type: "TICKETBUTLER_EXTERNAL_PAYMENT",
        active: false
      }, "*");
    }
  }, [isDetailIframe]);

  async function markFreePurchaseAsPaid() {
    try {
      // Mark purchase as PAID
      const req = await fetch(API_HOST + "/purchases/" + reservation.purchase.uuid + `/order-details/${isExtrasEvent ? "?checkout_flow=extras" : ""}`, {
        headers: makeTbRequestHeaders(language),
        method: "PUT",
        body: JSON.stringify({
          state: "PAID"
        })
      });

      if (req.ok) {
        return true;
      } else throw req;
    } catch (e) {
      console.error(e);

      if ( // User can click "OK" to try again, or dismiss the dialog and
      // click the UI Continue button again
      window.confirm(t("event.requestErrorTryAgain"))) {
        await markFreePurchaseAsPaid();
      } else return false;
    }
  }

  const hasRefundProtection = reservation.purchase.insurance && reservation.purchase.insurance.insurance_selected;
  const hasCO2Offset = reservation.purchase.co2_offset && reservation.purchase.co2_offset.is_selected;
  const hasServices = hasRefundProtection || hasCO2Offset;

  function makeAddressArr(obj) {
    const arrayOrder = ["venue", "street", "postcode+city", "country"];
    return arrayOrder.map(key => {
      if (key === "postcode+city") {
        const postcode = obj["postcode"];
        const city = obj["city"];
        return postcode !== undefined && city !== undefined ? `${postcode} ${city}` : "";
      } else {
        return obj[key];
      }
    }).filter(value => value?.trim() !== "" && value !== null);
  }

  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "checkoutModal"
  }, /*#__PURE__*/React.createElement(_StyledDiv2, null, currentStepID && checkoutSteps.length > 1 && /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(CheckoutProgressBar, {
    steps: checkoutSteps,
    currentStepID: currentStepID,
    color: theme.colour_primary,
    event: event,
    whitelabel: whitelabel,
    reservation: reservation
  })), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Extras.extrasTypes
  }, /*#__PURE__*/React.createElement(ExtrasTypes, {
    theme: theme,
    event: event,
    whitelabel: whitelabel,
    reservation: reservation,
    registrationFormValues: registrationFormValues,
    setRegistrationFormValues: setRegistrationFormValues,
    setOrderSummary: setOrderSummary,
    setReservation: setReservation,
    onSuccess: function () {
      checkoutNavigate(CHECKOUT_PATHS.OrderInformation.purchaseDetails);
    }
  })), /*#__PURE__*/React.createElement(PaymentRoute, {
    exact: true,
    path: path + "/checkout/"
  }, /*#__PURE__*/React.createElement(PurchaseDetails, {
    theme: theme,
    event: event,
    reservation: reservation,
    whitelabel: whitelabel,
    registrationFormValues: registrationFormValues,
    setRegistrationFormValues: setRegistrationFormValues,
    setOrderSummary: setOrderSummary,
    setReservation: setReservation,
    onSuccess: async function (res) {
      setReservation({ ...reservation,
        purchase: res.purchase,
        purchase_answers: res.purchase_answers
      });
      setOrderSummary(getOrderSummaryFromPurchase(res.purchase));
      const nextPath = getNextPath(res.purchase.purchase_is_free);

      if (res.purchase.purchase_is_free && nextPath === "success") {
        const markedAsPaid = await markFreePurchaseAsPaid();

        if (markedAsPaid) {
          checkoutNavigate(nextPath);
        }
      } else {
        checkoutNavigate(nextPath);
      }
    }
  })), /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Services.services
  }, /*#__PURE__*/React.createElement(Services, {
    theme: theme,
    event: event,
    reservation: reservation,
    whitelabel: whitelabel,
    orderSummary: orderSummary,
    setRegistrationFormValues: setRegistrationFormValues,
    setOrderSummary: setOrderSummary,
    setReservation: setReservation,
    onSuccess: async function () {
      const nextPath = getNextPath(reservation.purchase.purchase_is_free, true);

      if (reservation.purchase.purchase_is_free && nextPath === "success") {
        const markedAsPaid = await markFreePurchaseAsPaid();

        if (markedAsPaid) {
          checkoutNavigate(nextPath);
          return true;
        }
      } else {
        checkoutNavigate(nextPath);
        return true;
      }
    }
  })), /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.InformationPerGuest.attendeeDetails
  }, /*#__PURE__*/React.createElement(AttendeeQuestions, {
    theme: theme,
    event: event,
    reservation: reservation,
    registrationFormValues: registrationFormValues,
    setRegistrationFormValues: setRegistrationFormValues,
    onSuccess: async function () {
      const nextPath = getNextPath(reservation.purchase.purchase_is_free, true, true);

      if (reservation.purchase.purchase_is_free && nextPath === "success") {
        const markedAsPaid = await markFreePurchaseAsPaid();

        if (markedAsPaid) {
          checkoutNavigate(nextPath);
        }
      } else {
        checkoutNavigate(nextPath);
      }
    }
  })), /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.MobilePay.mobilePayCheckout
  }, /*#__PURE__*/React.createElement(MobilePayCheckout, {
    theme: theme,
    purchaseUUID: reservation.purchase.uuid,
    urlParameters: isIframe ? `${location.search}&iframe=true` : location.search
  })), /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Payment.stripe
  }, /*#__PURE__*/React.createElement(StripePayment, {
    theme: theme,
    purchaseUUID: reservation.purchase.uuid,
    whitelabel: whitelabel
  })), /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Payment.selectPayment
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP, {
    _css: styles.checkoutModalHeading
  }, t("event.choosePaymentMethod")), /*#__PURE__*/React.createElement(_StyledDiv4, null, // MobilePay option not enabled when STRIPE is the payment
  // provider, as it's used by non-Danish organisations
  whitelabel.payment_provider !== PAYMENT_PROVIDERS.STRIPE && whitelabel.payment_provider !== PAYMENT_PROVIDERS.STRIPE_CONNECT && whitelabel.mobile_pay_active && event.eventsettings.mobile_pay_active && /*#__PURE__*/React.createElement(_StyledDiv5, {
    onClick: function () {
      checkoutNavigate(CHECKOUT_PATHS.Payment.mobilepay);
    },
    _css2: [paymentOption, {
      width: "100%",
      maxWidth: 320,
      cursor: "pointer",
      marginBottom: 20,
      padding: 0
    }]
  }, /*#__PURE__*/React.createElement(_StyledImg, {
    src: mobilepayIcon
  })), /*#__PURE__*/React.createElement(_StyledDiv6, {
    onClick: function () {
      checkoutNavigate(CHECKOUT_PATHS.Payment[whitelabel.payment_provider === PAYMENT_PROVIDERS.STRIPE || whitelabel.payment_provider === PAYMENT_PROVIDERS.STRIPE_CONNECT ? "stripe" : "card"]);
    },
    _css3: [paymentOption, {
      textDecoration: "none",
      color: "initial"
    }]
  }, t("event.payWithCreditCard")), /*#__PURE__*/React.createElement(_StyledDiv7, {
    onClick: function () {
      checkoutNavigate(CHECKOUT_PATHS.Payment.invoice);
    },
    _css4: [paymentOption, {
      textDecoration: "none",
      color: "initial"
    }]
  }, t("event.invoiceOrEAN"))))), /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Payment.invoice
  }, /*#__PURE__*/React.createElement(InvoiceForm, {
    theme: theme,
    purchaseUUID: reservation.purchase.uuid
  })), eventSlug && /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Payment.card + "/"
  }, /*#__PURE__*/React.createElement(QuickPay, {
    theme: theme,
    purchaseUUID: reservation.purchase.uuid,
    urlParameters: isExtrasEvent ? makeSearchParamString(["checkout_flow", "extras"]) : makeSearchParamString(),
    whitelabel: whitelabel
  })), eventSlug && /*#__PURE__*/React.createElement(PaymentRoute, {
    path: path + "/checkout/" + CHECKOUT_PATHS.Payment.mobilepay + "/"
  }, /*#__PURE__*/React.createElement(QuickPay, {
    theme: theme,
    purchaseUUID: reservation.purchase.uuid,
    urlParameters: isExtrasEvent ? makeSearchParamString(["payment_methods", "mobilepay"], ["checkout_flow", "extras"]) : makeSearchParamString(["payment_methods", "mobilepay"]),
    whitelabel: whitelabel
  })), /*#__PURE__*/React.createElement(Route, {
    path: path + "/checkout/cancelled/"
  }, /*#__PURE__*/React.createElement(PurchaseCancelled, {
    theme: theme,
    purchase: reservation.purchase
  })), /*#__PURE__*/React.createElement(Route, {
    path: path + "/checkout/success/"
  }, /*#__PURE__*/React.createElement(PurchaseSuccess, {
    event: event,
    theme: theme // If we already have the purchase, use that
    ,
    purchase: reservation.purchase,
    whitelabel: whitelabel
  })), /*#__PURE__*/React.createElement(Route, {
    path: path + "/checkout/invoice-confirmation/"
  }, /*#__PURE__*/React.createElement(PurchaseSuccess, {
    event: event,
    theme: theme //when choosen payment is invoice we have to send to succes page prop
    ,
    paymentByInvoice: true // If we already have the purchase, use that
    ,
    purchase: reservation.purchase,
    whitelabel: whitelabel
  }))), /*#__PURE__*/React.createElement(_StyledDiv8, null, /*#__PURE__*/React.createElement(PoweredByTicketbutler, null))), /*#__PURE__*/React.createElement(_StyledDiv9, {
    _css5: CHECKOUT_DIALOG_BORDER_RADIUS,
    _css6: CHECKOUT_DIALOG_BORDER_RADIUS
  }, /*#__PURE__*/React.createElement(_StyledDiv10, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      paddingTop: "10px",
      fontWeight: 600,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, seatsHaveTicketTypeOptions ? t("event.totalReservations") + ": " : t("event.total") + ": ", /*#__PURE__*/React.createElement("span", null, whitelabel.numberFormat(reservation.purchase.total_and_all_fees_decimal))), !checkoutComplete && /*#__PURE__*/React.createElement(_StyledDiv11, null, /*#__PURE__*/React.createElement("span", null, t("event.youHave"), " "), countdownElement, /*#__PURE__*/React.createElement("span", null, " ", event.is_free_event ? t("event.toCompleteRegistration") : t("event.toCompleteOrder"), ".")))), /*#__PURE__*/React.createElement(_StyledDiv12, {
    _css7: [{
      padding: "0 10px",
      maxHeight: 920,
      margin: "0 auto",
      transition: "max-height 700ms ease-out",
      overflowY: "auto"
    }, !orderDetailsShown && {
      "@media (max-width: 760px)": {
        maxHeight: 0
      }
    }]
  }, !event.eventsettings.attach_voucher && event.event_type !== "GIFT_CARD" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledP2, {
    _css8: styles.checkoutOverviewHeading
  }, t("event.eventInformation")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "5px",
      fontSize: 15,
      fontWeight: "bold"
    }
  }, event.title), /*#__PURE__*/React.createElement(_StyledDiv13, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "9px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: calendarIcon,
    alt: ""
  })), /*#__PURE__*/React.createElement(_StyledDiv14, null, // When all ticket types being purchased have the same
  // start date and it's not extras event, show that date
  !isExtrasEvent && // The ticket summary can be empty when a user is brought
  // to the checkout to cancel their waiting list enrolment
  reservation.ticket_summary.length && reservation.ticket_summary.every(ticket => ticket.has_ticket_type_date && ticket.ticket_type_date === reservation.ticket_summary[0].ticket_type_date) ? formatDate(makeDate( // @ts-ignore: Not picking up the ternary check above
  reservation.ticket_summary[0].ticket_type_date, true), language === "da" ? "da-DK" : undefined) : // If there are two or more ticket types being purchased
  // and any have start dates are not all the same, show a
  // message instead of a date
  reservation.ticket_summary.length > 1 && !reservation.ticket_summary.every(ticketType => ticketType.ticket_type_date === reservation.ticket_summary[0].ticket_type_date) ? t("event.multipleStartingTimes") : event.end_date ? formatDateTimeRange(makeDate(event.start_date, true), makeDate(event.end_date, true), {
    dateLocale: language === "da" ? "da-DK" : undefined,
    shortForm: window.innerWidth < 420
  }) : formatDate(makeDate(event.start_date, true), language === "da" ? "da-DK" : undefined))), (event.address.venue || event.address.street || event.address.postcode || event.address.country) && /*#__PURE__*/React.createElement(_StyledDiv15, null, makeAddressArr(event.address).map((elem, i) => {
    if (i === 0) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(_StyledImg2, {
        src: locationIcon
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: "2.5px 0 0 0",
          fontSize: 14
        }
      }, elem));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          margin: "2.5px 0 2.5px 27px",
          fontSize: 14
        }
      }, elem);
    }
  }))), /*#__PURE__*/React.createElement(_StyledP3, {
    _css9: styles.checkoutOverviewHeading
  }, event.is_free_event ? t("event.registrationSummary") : t("event.orderSummary")), /*#__PURE__*/React.createElement(_StyledTable, null, /*#__PURE__*/React.createElement(_StyledTbody, null, reservation.ticket_summary.map((ticket, index) => /*#__PURE__*/React.createElement(_StyledTr, {
    key: index
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(_StyledDiv16, null, ticket.ticket_title), /*#__PURE__*/React.createElement("div", null, ticket.attributes ? //If extra has attributes, show the quantity and name of each attribute selected
  Object.entries(ticket.attributes).map(([attributeQuantity, attributeName], i) => /*#__PURE__*/React.createElement(_StyledDiv17, {
    key: i
  }, `${attributeQuantity}: ${attributeName} x ${whitelabel.numberFormat(ticket.ticket_price)}`)) : `${ticket.amount_of_tickets} x ${whitelabel.numberFormat(ticket.ticket_price)}`)), /*#__PURE__*/React.createElement(_StyledTd, null, ticket.attributes ? Object.entries(ticket.attributes).map(([key, value], i) => {
    const attriQuantity = value !== undefined ? value : 0;
    return /*#__PURE__*/React.createElement(_StyledDiv18, {
      key: i
    }, whitelabel.numberFormat(ticket.ticket_price * attriQuantity), " ");
  }) : /*#__PURE__*/React.createElement("div", null, whitelabel.numberFormat(ticket.ticket_total), " ")))), (registrationFormValues.send_sms_tickets !== undefined ? registrationFormValues.send_sms_tickets : reservation.purchase.send_sms_tickets) && // Has the user selected "Yes" to SMS ticket
  // Is the purchase paid? (SMS not valid for free orders)
  !reservation.purchase.purchase_is_free && /*#__PURE__*/React.createElement("tr", {
    "data-testid": "sms-ticket"
  }, /*#__PURE__*/React.createElement("td", null, t("event.SMSTicket")), /*#__PURE__*/React.createElement(_StyledTd2, null, whitelabel.numberFormat(reservation.purchase.fee_per_sms), " ")), orderSummary.discount && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("event.ticketDiscountCode")), /*#__PURE__*/React.createElement(_StyledTd3, null, "-", whitelabel.numberFormat(reservation.purchase.discount_total), " ")), orderSummary.gift_card && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("event.giftCard")), /*#__PURE__*/React.createElement(_StyledTd4, null, "-", whitelabel.numberFormat(reservation.purchase.gift_card_total), " ")), !event.eventsettings.organizer_absorb_fees && orderSummary.ticket_fee_total && orderSummary.ticket_fee_total !== "0.00" && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("event.ticketFees")), /*#__PURE__*/React.createElement(_StyledTd5, null, /*#__PURE__*/React.createElement("span", null, whitelabel.numberFormat(orderSummary.ticket_fee_total), " "))), hasRefundProtection && /*#__PURE__*/React.createElement("tr", {
    "data-testid": "refund-protection"
  }, /*#__PURE__*/React.createElement("td", null, t("event.refundProtection")), /*#__PURE__*/React.createElement(_StyledTd6, null, whitelabel.numberFormat(reservation.purchase.insurance.premium), " ")), hasCO2Offset && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(_StyledDiv19, null, t("event.co2Offsetting")), /*#__PURE__*/React.createElement("div", null, `${reservation.purchase.co2_offset.total_price / whitelabel.fee_per_co2_offset} x ${whitelabel.numberFormat(whitelabel.fee_per_co2_offset)}`)), /*#__PURE__*/React.createElement(_StyledTd7, null, whitelabel.numberFormat(reservation.purchase.co2_offset.total_price))), Number(reservation.purchase.transaction_fee) > 0 && /*#__PURE__*/React.createElement(_StyledTr2, null, /*#__PURE__*/React.createElement("td", null, t("event.transactionFee")), /*#__PURE__*/React.createElement(_StyledTd8, null, whitelabel.numberFormat(reservation.purchase.transaction_fee))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(_StyledTd9, null, /*#__PURE__*/React.createElement("strong", null, t("event.total").toUpperCase())), /*#__PURE__*/React.createElement(_StyledTd10, null, /*#__PURE__*/React.createElement("strong", null, whitelabel.numberFormat(reservation.purchase.total_and_all_fees_decimal)))), orderSummary.total > 0 && /*#__PURE__*/React.createElement(_StyledTr3, null, /*#__PURE__*/React.createElement("td", null, t("event.hereofVAT")), /*#__PURE__*/React.createElement(_StyledTd11, null, whitelabel.numberFormat( // If the event is VAT exempt, no VAT on the sale price
  // of Ticketbutler offered items (tickets or extras) is
  // applicable
  (event.eventsettings.vat_exempt ? 0 : parseFloat(orderSummary.vat_total)) + ( // VAT applicable for the tickets/extras fee
  reservation.purchase.organizer_absorb_fees ? 0 : parseFloat(orderSummary.fee_total_vat)) + // VAT applicable for the services (not provided by Ticketbutler)
  parseFloat(orderSummary.service_vat)))))), !checkoutComplete && /*#__PURE__*/React.createElement(_StyledDiv20, null, /*#__PURE__*/React.createElement("span", null, t("event.youHave"), " "), countdownElement, /*#__PURE__*/React.createElement("span", null, " ", event.is_free_event ? t("event.toCompleteRegistration") : t("event.toCompleteOrder"), ".")), " ", event.has_seating && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP4, {
    _css10: styles.checkoutOverviewHeading
  }, t("event.seatingInformation")), /*#__PURE__*/React.createElement("div", null, reservation.ticket_summary.reduce((acc, ticketType) => {
    for (let i = 0; i < ticketType.seating.length; i++) {
      const seat_summary = ticketType.seating[i];
      acc.push({
        // We don't have the seat UUID here, so let's use the ticket type
        // and index to assign in a unique value uuid: ticketType.ticket_type_uuid + "-" + i
        ticketTypeUUID: ticketType.ticket_type_uuid,
        type: seat_summary.is_booth ? "Booth" : seat_summary.table ? "Table" : seat_summary.general_admission_area ? "GeneralAdmissionArea" : "Seat",
        parentType: seat_summary.table ? "table" : seat_summary.row ? "row" : undefined,
        section: seat_summary.section,
        parent: seat_summary.table || seat_summary.row,
        label: seat_summary.label || seat_summary.general_admission_area
      });
    }

    return acc;
  }, []).map((seat, index) => {
    const ticketType = ticketTypesByUUID[seat.ticketTypeUUID];
    return /*#__PURE__*/React.createElement(_StyledDiv21, {
      key: index
    }, /*#__PURE__*/React.createElement(SeatingDetails, {
      seat: seat,
      whitelabel: whitelabel,
      ticketType: ticketType
    }));
  })))), /*#__PURE__*/React.createElement(_StyledDiv22, {
    role: "button",
    onClick: function () {
      setOrderDetailsShown(state => !state);
    }
  }, /*#__PURE__*/React.createElement(_StyledDiv23, null, orderDetailsShown ? t("event.hideSummary") : event.is_free_event ? t("event.viewRegistrationSummary") : t("event.viewOrderSummary")), /*#__PURE__*/React.createElement(_StyledDiv24, {
    _css11: [{
      marginLeft: 3,
      transition: "transform 300ms"
    }, orderDetailsShown && {
      transform: `rotate(180deg) translateY(-2px)`
    }]
  }, "\u25BE")), /*#__PURE__*/React.createElement(_StyledDiv25, null, /*#__PURE__*/React.createElement(PoweredByTicketbutler, null))));
}

function CheckoutProgressBar(props) {
  const {
    t
  } = useTranslation();
  const customNewsTitle = // @ts-ignore: News step bar should be dynamic
  props.whitelabel["news_checkout_step_" + useLanguage()];
  const stepLabels = React.useMemo(() => {
    const result = [];

    for (let index = 0; index < props.steps.length; index++) {
      const stepID = props.steps[index];

      switch (stepID) {
        case CheckoutSteps.OrderInformation:
          result.push(props.event.is_free_event ? t("event.registrationInfo") : t("event.customerInfo"));
          break;

        case CheckoutSteps.Extras:
          result.push(t("event.extras"));
          break;

        case CheckoutSteps.Services:
          result.push(customNewsTitle ? customNewsTitle : props.event.is_free_event || props.reservation.purchase.purchase_is_free ? t("event.news") : t("event.services"));
          break;

        case CheckoutSteps.InformationPerGuest:
          result.push(
          /*if event doesn't have tickets change wording*/
          props.event.eventsettings.generate_ticket_pdf !== false ? props.event.event_type === "GIFT_CARD" ? t("event.receiverInformation") : t("event.informationPerTicket") : t("event.informationPerReservation"));
          break;

        case CheckoutSteps.Payment:
          result.push(t("event.payment"));
          break;

        case CheckoutSteps.MobilePay:
          result.push("MobilePay");
          break;

        default:
          continue;
      }
    }

    return result;
  }, [props.event.eventsettings.generate_ticket_pdf, props.event.is_free_event, props.reservation.purchase.purchase_is_free, props.event.event_type, props.steps, customNewsTitle, t]);
  const currentStepIndex = React.useMemo(() => {
    return props.steps.findIndex(id => {
      return id === props.currentStepID;
    });
  }, [props.steps, props.currentStepID]);
  return /*#__PURE__*/React.createElement(ProgressBar, {
    color: props.color,
    percentage: currentStepIndex / ( // Take one off so that the bar highlights to each point
    props.steps.length - 1) * 100,
    transitionSpeed: 300,
    milestoneWidth: 35,
    milestoneCount: props.steps.length,
    Milestone: milestone => /*#__PURE__*/React.createElement(CheckoutStepItem, _extends({}, milestone, {
      color: props.color,
      label: t(stepLabels[milestone.index]) || ""
    })),
    CurrentMilestone: milestone => /*#__PURE__*/React.createElement(CheckoutStepItem, _extends({}, milestone, {
      color: props.color,
      label: t(stepLabels[milestone.index]) || "",
      current: true
    })),
    CompletedMilestone: milestone => /*#__PURE__*/React.createElement(CheckoutStepItem, _extends({}, milestone, {
      color: props.color,
      label: t(stepLabels[milestone.index]) || ""
    }))
  });
}

var _StyledDiv26 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv26",
  componentId: "sc-1fg0buz-47"
})({
  // This is a bit of an opacity hack so you can't see the progress bar
  // behind inactive steps
  backgroundColor: "white",
  border: "4px solid white"
});

var _StyledDiv27 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv27",
  componentId: "sc-1fg0buz-48"
})(p => ({
  opacity: p._css12,
  transition: "300ms opacity"
}));

var _StyledDiv28 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv28",
  componentId: "sc-1fg0buz-49"
})(p => ({
  width: 35,
  height: 35,
  borderRadius: "50%",
  backgroundColor: p._css13,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  fontSize: 16,
  fontWeight: 600
}));

var _StyledDiv29 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv29",
  componentId: "sc-1fg0buz-50"
})(["", ""], p => p._css14);

function CheckoutStepItem({
  index,
  current,
  label,
  color = "black"
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv26, {
    key: index
  }, /*#__PURE__*/React.createElement(_StyledDiv27, {
    _css12: current ? 1 : 0.25
  }, /*#__PURE__*/React.createElement(_StyledDiv28, {
    _css13: color
  }, index + 1), /*#__PURE__*/React.createElement(_StyledDiv29, {
    _css14: [{
      width: 120,
      position: "absolute",
      top: "110%",
      left: "50%",
      transform: "translateX(-50%)",
      fontSize: 13,
      textAlign: "center"
    }, current && {
      fontWeight: 600
    }]
  }, label)));
} // This is the Checkout modal wrapper which handles the outer styling,
// accessibility and cancellation warnings when a user tries to close it.


export function CheckoutDialog({
  isOpen,
  children,
  resetToSeating,
  whitelabel,
  onClose
}) {
  const language = useLanguage();
  const {
    eventSlug
  } = useParams();
  const {
    warnBeforeExit,
    setCheckoutContext
  } = React.useContext(CheckoutContext);
  const history = useHistory();
  const {
    t
  } = useTranslation();

  async function handleClose() {
    const nextUrlParams = resetToSeating ? makeSearchParamString(["show_map", "true"], ["purchase_uuid", undefined]) : makeSearchParamString(["purchase_uuid", undefined]);
    const nextPath = [`/${language}/e`, eventSlug, resetToSeating && "seats", nextUrlParams].filter(Boolean).join("/");

    if (warnBeforeExit) {
      // Confirm before closing modal
      if (window.confirm(t("event.reservationWillBeLost"))) {
        await releaseSeatsioObjects();
        history.push(nextPath);
        setCheckoutContext(s => ({ ...s,
          warnBeforeExit: false
        }));

        if (onClose) {
          onClose();
        }
      }
    } else {
      await releaseSeatsioObjects();
      history.push(nextPath);
      setCheckoutContext(s => ({ ...s,
        warnBeforeExit: false
      }));

      if (onClose) {
        onClose();
      }
    }
  }

  React.useEffect(function () {
    // Confirm before closing window
    function confirmWindowClose(e) {
      e.preventDefault();
      return "Are you sure? Your reservation will be lost.";
    }

    if (warnBeforeExit && isOpen) {
      window.addEventListener("beforeunload", confirmWindowClose);
    } else {
      // Remove the listener if the value changes
      window.removeEventListener("beforeunload", confirmWindowClose);
    }

    return function () {
      window.removeEventListener("beforeunload", confirmWindowClose);
    };
  }, [warnBeforeExit, isOpen]);
  return /*#__PURE__*/React.createElement(RegistrationDialog, {
    isOpen: isOpen,
    onDismiss: handleClose,
    whitelabel: whitelabel
  }, children);
}
export function useCheckoutNavigate() {
  const history = useHistory();
  const language = useLanguage();
  const {
    eventSlug
  } = useParams();
  return function (checkoutPath) {
    history.push([`/${language}/e`, eventSlug, CHECKOUT_ROUTE, checkoutPath === "/" ? null : checkoutPath, makeSearchParamString()].filter(Boolean).join("/"));
  };
}
export function useExistingReservationInParam() {
  const language = useLanguage(); // If we are coming back from a payment gateway let's get the purchase UUID
  // from the query.

  const {
    trigger: getExistingReservation,
    status,
    reset,
    lastResult,
    lastError
  } = useAsyncStatus(async function getExistingReservation(purchaseUUID) {
    const req = await fetch([API_HOST, "purchases", purchaseUUID, `order-details/${urlParams.get("extras_flow") ? "?checkout_flow=extras" : ""}`].join("/"), {
      headers: makeTbRequestHeaders(language)
    });
    const res = await req.json();

    if (req.ok) {
      // By filling the `lastResult` the app knows to continue with the
      // existingReservation in the checkout flow
      return res;
    } else {// If there is purchase, or is not able to be completed, the API responds
      // with a message eg. "The order has been cancelled".
      //
      // Removed this alert since timing out will then throw 2 alerts
      // window.alert(res.non_field_errors.join(" "));
    }
  }, []);
  React.useEffect(function () {
    // Check if we have an existing purchase.
    // If we do, fetch it
    const searchParams = getSearchParams();
    const purchaseUUID = searchParams.purchase_uuid;

    if (purchaseUUID) {
      getExistingReservation(purchaseUUID);
    }
  }, [getExistingReservation]);
  return {
    status,
    reset,
    lastResult,
    lastError
  };
} // Determine whether the user should be shown the services page in the
// checkout flow

function getShowServicesPage(purchaseIsFree, payByInvoiceOptional, payByInvoiceOnly, whitelabel, event) {
  return (// We want to show the services page if the CO2 or Insurance features
    // are available. UNLESS the purchase is free, paid by invoice,
    // or a it's gift card event
    !purchaseIsFree && !payByInvoiceOptional && !payByInvoiceOnly && event.event_type !== "GIFT_CARD" && (whitelabel.insurance_active || event.is_co2_usable)
  );
}

var _StyledDiv30 = _styled("div").withConfig({
  displayName: "checkout___StyledDiv30",
  componentId: "sc-1fg0buz-51"
})({
  display: "flex",
  flexDirection: "column",
  textAlign: "right",
  lineHeight: 1.4
});

function PoweredByTicketbutler() {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_StyledDiv30, null, /*#__PURE__*/React.createElement("span", null, t("event.ticketingPoweredBy"), ":"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
    href: "https://ticketbutler.io/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Ticketbutler"), " ", "(" + t("event.CVRNumber") + ": DK-38404687)"));
}